import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/system/enterprises/')({
  beforeLoad: () => {
    throw redirect({ to: '/operations/enterprises', replace: true });
  },
});
